// extracted by mini-css-extract-plugin
module.exports = {"root":"premium_root__CB9dj","compact":"premium_compact__ib8Zq","imagine":"premium_imagine__TCYgt"};